import {
  CASE_ID,
  OFFER_CASE_ID,
  CASE_SUBTYPE,
  CASE_TYPE_EXISTING,
  BROWSER_REDIRECT_URL,
  LINK_CODE_KEY,
  PRODUCT_NAME
} from './constants';
import { getQueryStringValueByName, getHrefOnBrowserLoad } from '.';
import { selectors } from '../infrastructure/config';
import { changeWindowHref } from './redirectUtils';

const sessionRedirectUtil = {
  getRedirectUrl(state) {
    const caseId = this.getCaseId(selectors, state);
    const brandId = selectors.brandId(state) || 'VM';
    const linkCode = selectors.getSingleEntry(state, LINK_CODE_KEY);
    const url = state.config;
    const saveResumeUrl = url
      ? encodeURIComponent(`${url.toJS().businessAccountsUrl}?type=resume`)
      : '';
    const productName = state.config.get(PRODUCT_NAME);
    if (productName) {
      sessionStorage.setItem(PRODUCT_NAME, productName);
    }
    return this.generateUrl(caseId, linkCode, state, url, brandId, saveResumeUrl);
  },

  generateUrl(caseId, linkCode, state, url, brandId, saveResumeUrl) {
    if (caseId) {
      return `${
        url.toJS().authenticationUrl
      }/${brandId}?client_id=vmbaa_web&response_type=token&redirect_uri=${saveResumeUrl}`;
    }
    if (linkCode) {
      return getHrefOnBrowserLoad();
    }
    const case_type =
      selectors.getSingleEntry(state, CASE_SUBTYPE) || getQueryStringValueByName(CASE_SUBTYPE);
    const access_token = selectors.accessToken(state);

    if (access_token && case_type === CASE_TYPE_EXISTING) {
      const idvUrl = getIDandVUrl(url, brandId);
      return idvUrl;
    }
    return '';
  },

  getCaseId(selectors, state) {
    return (
      selectors.getSingleEntry(state, CASE_ID) ||
      getQueryStringValueByName(CASE_ID) ||
      getQueryStringValueByName(OFFER_CASE_ID)
    );
  },
  onBrowserRefresh(state) {
    sessionStorage.setItem(BROWSER_REDIRECT_URL, this.getRedirectUrl(state));
  },

  getRefreshUrl() {
    const url = sessionStorage.getItem(BROWSER_REDIRECT_URL);
    const URL_LIMIT_LENGTH = 4;
    if (url && url.length < URL_LIMIT_LENGTH) {
      sessionStorage.setItem(BROWSER_REDIRECT_URL, '');
    }
    return url;
  },

  getRefreshUrlAndCleanStorage() {
    const url = sessionStorage.getItem(BROWSER_REDIRECT_URL);
    sessionStorage.setItem(BROWSER_REDIRECT_URL, '');
    return url;
  },

  redirectOnRefresh() {
    const refreshUrl = sessionRedirectUtil.getRefreshUrlAndCleanStorage();
    if (refreshUrl) {
      changeWindowHref(refreshUrl);
    }
  }
};

const getIDandVUrl = (url, brandId) => {
  if (url) {
    const idv = url.toJS().authenticationUrl;
    const baa = url.toJS().businessAccountsUrl;
    return `${idv}/${brandId}?client_id=vmbaa_web&response_type=token&redirect_uri=${baa}`;
  }
  return '';
};

export default sessionRedirectUtil;
